export default {
  namespaced: true,
  state: {
    products: [
      {
        id: 1,
        image: "04.jpg",
        code: 1,
        name: "منتج #1",
        quantity: 2,
        showQuantity: true,
        viewInStore: true,
        viewInPlatform: false,
        isActive: true,
        isPinned: true,
      },
      {
        id: 2,
        image: "02.jpg",
        code: null,
        name: null,
        quantity: null,
        showQuantity: false,
        viewInStore: false,
        viewInPlatform: true,
        isActive: false,
        isPinned: false,
      },
      {
        id: 3,
        image: "03.jpg",
        code: 3,
        name: "منتج #3",
        quantity: 50,
        showQuantity: true,
        viewInStore: true,
        viewInPlatform: true,
        isActive: true,
        isPinned: true,
      },
    ],
  },
  getters: {
    getProduct(state) {
      return state.products;
    },
  },
  mutations: {},
  actions: {},
};
